import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'

/**
 * Položky
 */
export default class TSpecialKanbanKanbanItem extends Data {
	public static className = 'TSpecialKanbanKanbanItem'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Master
	 */
	Master?: number

	/**
	 * Fixní kód
	 */
	IsFixedCode?: string

	/**
	 * Datum zaskladnění
	 */
	InStockDate?: Date

	/**
	 * Datum vrácení
	 */
	ReturnDate?: Date

	/**
	 * Datum výstupu
	 */
	OutputDate?: Date

	/**
	 * Zkratka
	 */
	Abbr?: string

	/**
	 * Item id
	 */
	ItemId?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * RecordMod
	 */
	RecordMod?: number

	/**
	 * RecordES
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * RecordState
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Stav
	 */
	StatusCalc?: number
}